import { ts } from '_core';

import { getName, validate } from './helpers';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.RISK_MODEL_BIAS_STATISTIC_BY_BETA,
    title: 'Bias Statistic by Historical Beta',
    helpLabel: 'y5as3svq74',
    form: false,
    // For old version of the widget (before it needed windows)
    neededFiles: ['risk_model_bias_statistic_by_beta'],
    tags: [
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.RISK_MODEL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.COMMON_RISK_MODEL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.STATISTICAL_RISK_MODEL,
    ],
    validate,
    getName,
  },
] satisfies ts.types.analysis.WidgetConfig[];
